<div class="bg-light">
  <div class="container">
      <div class="inner-wrapper">
    <router-outlet></router-outlet>
</div>
  </div>
</div>
  
